import React, { useState, useEffect } from 'react';
import "./CustomBreadcrumb.css";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {useNavigate} from "react-router-dom"


const CustomBreadcrumb = () => {

    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);
    const navigate = useNavigate()
  
  return (
    <nav class="breadcrumb-one" aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item"><a onClick={() => navigate(`${states.breadcrumbContent.firstLevelLink}`)}>{states.breadcrumbContent.firstLevelText}</a></li>
        <li class="breadcrumb-item"><a onClick={() => navigate(`${states.breadcrumbContent.secondLevelLink}`)}>{states.breadcrumbContent.secondLevelText}</a></li>
        { states.breadcrumbContent.thirdLevelText != "" && <li class="breadcrumb-item"><a onClick={() => navigate(`${states.breadcrumbContent.thirdLevelLink}`)} >{states.breadcrumbContent.thirdLevelText}</a></li>}
    </ol>
</nav>
  )
}

export default CustomBreadcrumb